export const initialState = {
  countyAdminData: [],
  globalAdminData: [],
  clinicAdminData: []
};
